<template>
  <!-- prettier-ignore -->
  <div class="comparison-link">
    <Form.Button
      plain
      @click="open"
    >
      <slot />
    </Form.Button>

    <the-modal
      v-model="show"
      open
    >
      <comparison-content
        :content="content"
        :product="product"
        :type="type"
      />
    </the-modal>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { events$ } from '@/services'

import * as Form from '@/components/Form'
import ComparisonContent from '@/components/Comparison/Content'

import { EVENT_PRODUCT } from '@/config/events'

// Props
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },

  product: {
    type: Object,
    required: true,
  },

  type: {
    type: String,
    required: true,
  },

  source: {
    type: String,
    required: true,
  },
})

// Data
const show = ref(false)

// Methods
function open() {
  show.value = true
  events$.emit(EVENT_PRODUCT.DETAIL_OPEN, {
    categoryId: props.categoryId,
    productId: props.product.productId,
    type: props.type,
    source: props.source,
  })
}
</script>

<style scoped>
.comparison-link {
  display: inline-block;
  color: var(--c-primary-neutral-1);
  width: 100%;
  min-height: 50px;

  .button {
    border: 0;
    padding: 0;
    height: 25px;
    min-height: 25px;
    font-weight: bold;
    justify-content: flex-start;
    color: var(--c-primary-color-3);
  }
}
</style>
